import { render } from "./CloseButton.vue?vue&type=template&id=f5b0ebce&scoped=true&ts=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=f5b0ebce&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b0ebce"]])

export default __exports__